import React from 'react';
import './WriteForUsPage.css';

const WriteForUsPage = () => {
  return (
    <div className="page-wrapper">
      <div className="write-for-us-page">
        {/* Hero Section */}
        <section className="write-hero">
          <div className="container">
            <div className="hero-content">
              <h1>Write for Prime Care Dental</h1>
              <p className="hero-subtitle">
                Share Your Dental Expertise & Help Educate Our Community
              </p>
              <p className="hero-description">
                Prime Care Dental is committed to providing valuable, evidence-based dental health information 
                to our community in Lahore and beyond. We're looking for passionate dental professionals, health writers, 
                and industry experts to contribute to our educational content.
              </p>
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">10K+</span>
                  <span className="stat-label">Monthly Readers</span>
                </div>
                <div className="stat">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Published Articles</span>
                </div>
                <div className="stat">
                  <span className="stat-number">15+</span>
                  <span className="stat-label">Expert Contributors</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="about-writing">
          <div className="container">
            <div className="content-grid">
              <div className="content-text">
                <h2>Why Write for Us?</h2>
                <p>
                  Prime Care Dental is committed to providing valuable, evidence-based dental health information 
                  to our community in Lahore and beyond. We're looking for passionate dental professionals, health writers, 
                  and industry experts to contribute to our educational content.
                </p>
                <div className="benefits-list">
                  <div className="benefit">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
                    </svg>
                    <span>Reach thousands of patients and professionals</span>
                  </div>
                  <div className="benefit">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
                    </svg>
                    <span>Build your professional reputation</span>
                  </div>
                  <div className="benefit">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
                    </svg>
                    <span>Share your expertise with a wider audience</span>
                  </div>
                  <div className="benefit">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
                    </svg>
                    <span>Get quality backlinks to your practice</span>
                  </div>
                </div>
              </div>
              <div className="content-image">
                <img 
                  src="https://plus.unsplash.com/premium_photo-1661757246834-15dabcce9587?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="Medical writing and research"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Topics Section */}
        <section className="topics-section">
          <div className="container">
            <h2>Topics We're Looking For</h2>
            <p className="section-intro">
              We welcome high-quality, original content on various dental health topics. 
              Here are some areas we're particularly interested in:
            </p>
            <div className="topics-grid">
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <h3>General Dentistry</h3>
                <p>Comprehensive dental care, fillings, and preventive treatments</p>
              </div>
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <h3>Orthodontic Treatment</h3>
                <p>Braces, aligners, and teeth straightening procedures</p>
              </div>
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
                  </svg>
                </div>
                <h3>Preventive Care</h3>
                <p>Oral hygiene, scaling, polishing, and prevention strategies</p>
              </div>
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                  </svg>
                </div>
                <h3>Restorative Dentistry</h3>
                <p>Root canal therapy, dental implants, and tooth restoration</p>
              </div>
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2z"/>
                  </svg>
                </div>
                <h3>Pediatric Dentistry</h3>
                <p>Children's oral health and family dental care</p>
              </div>
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2-7h-3V2h-2v2H8V2H6v2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H3V9h16v11z"/>
                  </svg>
                </div>
                <h3>Patient Education</h3>
                <p>Treatment explanations and oral health awareness</p>
              </div>
              <div className="topic-card">
                <div className="topic-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                  </svg>
                </div>
                <h3>Practice Management</h3>
                <p>Business insights and practice optimization</p>
              </div>
            </div>
          </div>
        </section>

        {/* Guidelines Section */}
        <section className="guidelines-section">
          <div className="container">
            <div className="guidelines-content">
              <h2>Submission Guidelines</h2>
              <div className="guidelines-grid">
                <div className="guideline-card">
                  <h3>Content Requirements</h3>
                  <ul>
                    <li>Original, unpublished content only</li>
                    <li>Minimum 800-1500 words</li>
                    <li>Evidence-based and factually accurate</li>
                    <li>Professional, engaging writing style</li>
                    <li>Proper citations for medical claims</li>
                  </ul>
                </div>
                <div className="guideline-card">
                  <h3>Author Qualifications</h3>
                  <ul>
                    <li>Licensed dental professionals</li>
                    <li>Healthcare writers with dental expertise</li>
                    <li>Dental students (final year)</li>
                    <li>Industry experts and researchers</li>
                    <li>Must provide credentials and bio</li>
                  </ul>
                </div>
                <div className="guideline-card">
                  <h3>Technical Specifications</h3>
                  <ul>
                    <li>Submit in Google Docs or Word format</li>
                    <li>Include relevant images (high-resolution)</li>
                    <li>Use proper headings and formatting</li>
                    <li>Include meta description (150-160 chars)</li>
                    <li>Suggest relevant tags/keywords</li>
                  </ul>
                </div>
                <div className="guideline-card">
                  <h3>Review Process</h3>
                  <ul>
                    <li>Initial review within 5-7 business days</li>
                    <li>Editorial feedback and revision requests</li>
                    <li>Final approval and publication scheduling</li>
                    <li>Author notification upon publication</li>
                    <li>Performance metrics shared monthly</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Share Your Expertise?</h2>
              <p>
                Join our community of dental professionals and help us educate patients about oral health in Pakistan. 
                We look forward to featuring your insights on our platform.
              </p>
              <div className="cta-buttons">
                <a href="mailto:primecare.dental@gmail.com" className="cta-btn primary">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                  </svg>
                  Submit Your Article
                </a>
                <a href="/contact" className="cta-btn secondary">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 6L12 10.5 8.5 8 12 5.5 15.5 8zM8.5 16L12 13.5 15.5 16 12 18.5 8.5 16z"/>
                  </svg>
                  Have Questions?
                </a>
              </div>
              <div className="contact-info">
                <div className="contact-card">
                  <h3>Editorial Guidelines & Contact</h3>
                  <div className="contact-details">
                    <p>
                      <strong>Editorial Contact:</strong> primecare.dental@gmail.com<br/>
                      <strong>Response Time:</strong> 3-5 business days<br/>
                      <strong>Word Count:</strong> 800-2000 words preferred
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WriteForUsPage; 